import { SegmentType } from 'modules/Search/constants';

export type ModalType = 'List' | 'Create' | 'Edit' | 'Delete';

export type PriceAlertStatus = 'ACTIVE' | 'TRIGGERED';

export enum AlertStatusFilter {
  ALL = 'ALL',
  ACTIVE = 'ACTIVE',
  TRIGGERED = 'TRIGGERED',
}

export type PriceAlertRule = {
  type: 'ABOVE' | 'BELOW';
  value: number;
  notes: string;
  status?: PriceAlertStatus;
};

export type PriceAlert = {
  id: string;
  instrumentKey: string;
  compareWith?: 'LTP';
  rules: PriceAlertRule[];
};

export type PostAlertResponse = {
  success: boolean;
  error?: {
    code: number;
    message: string;
  };
  id: string;
  expiresOn: number;
  createdAt: number;
  updatedAt: number;
};

export type GetPriceAlertObject = PriceAlert & {
  createdAt: number;
  updatedAt: number;
  formattedInstrument: string;
  instrument: Instrument;
};

export type GetPriceAlertResponse = {
  priceAlerts: GetPriceAlertObject[];
};

export type GeneratePriceAlertPayload = 'CREATE' | 'EDIT';

export type PriceAlertType = 'ABOVE' | 'BELOW';

export type AlertPayload = {
  compareWith: string;
  rules: Omit<PriceAlertRule, 'status'>[];
  instrumentKey?: string;
}

export type PriceAlertNotification = {
  id: string;
  s: string;
  t: string;
  e: SegmentType;
  ltp: string;
  text: string;
  type: string;
  value: string;
  token: string;
};
